





























































































import { Component, Vue } from "vue-property-decorator";
import SystemConst from "@/config/const";
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
firebase.auth().languageCode = "ja";

@Component
export default class SettingPasswordApp extends Vue {
  nowPassword = "";
  newPassword = "";
  newPasswordConfirm = "";
  message = "";
  settingType = SystemConst.SETTING_TYPE;
  selectedSettingType = "SettingPassword";
  showPassword = {
    nowPassword: false,
    newPassword: false,
    newPasswordConfirm: false
  };
  isProcessing = false;
  user = {
    name: null,
    email: null
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private rulePassword: any = [
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (v: any) => !!v || "入力が必須です。",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (v: any) =>
      /^(?=.*?[a-z])(?=.*?\d)[a-z\d]{8,100}$/i.test(v) ||
      "半角英数8文字以上(英文字と数字共に必須)です。",
  ];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get refs(): any {
    return this.$refs;
  }

  setPassword() {
    this.message = "";
    if (this.refs.setPasswordForm.validate()) {
      this.doSetPassword();
    }
  }

  changePage() {
    const selectedSetting = this.selectedSettingType;
    this.$router.push({ name: selectedSetting });
  }

  async doSetPassword() {
    // ログイン情報を最新にする
    const user = firebase.auth().currentUser;
    if (user != null && user.email != null) {
      this.isProcessing = true;
      const credential = firebase.auth.EmailAuthProvider.credential(
        user.email,
        this.nowPassword
      );
      await user
        .reauthenticateWithCredential(credential)
        .then(async () => {
          await user
            .updatePassword(this.newPassword)
            .then(() => {
              const functions = firebase.app().functions("asia-northeast1");
              const func = functions.httpsCallable("changePassword");
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              func({ email: user.email, name: this.user.name });
              this.message = "新しいパスワードを設定しました。";
            })
            .catch(() => {
              this.message = "パスワード更新でエラーが発生しました。";
            });
        })
        .catch(() => {
          this.message =
            "パスワードが一致しないか、メールアドレス認証で登録していません。";
        });
      this.isProcessing = false;
    }
  }

  public mounted() {
    document.title =
      "パスワードを変更する | favsalon(ファブサロン) | 再来率を向上させるサロンに特化したネットショップサービス";
    const descriptonMeta = document.querySelector("meta[name='description']");
    if (descriptonMeta) {
      descriptonMeta.setAttribute(
        "content",
        "パスワードを変更する | favsalon（ファブサロン）なら美容室やネイルサロン、リラクサロンなどのサロンメニューに特化したネットサロンを簡単に作ることができます。シークレットメニューで来店者のみに販売するサービスを作って再来率を向上させます！"
      );
    }
    const robotsMeta = document.querySelector("meta[name='robots']");
    if (robotsMeta) {
      robotsMeta.setAttribute("content", "noindex");
    }
  }

  public created() {
    this.user = this.$store.getters.user;
  }
}
